/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.getUploadLimits'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  canUpload: /*#__PURE__*/ l.boolean(),
  remainingDailyBytes: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  remainingDailyVideos: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get video upload limits for the authenticated user. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
